<template>
  <div class="row">
    <div class="col-4 text-right">
      <label :class="{ failed: property.failed }">
        <span>{{property.question}}</span>
      </label>
      <span class="ml-1" v-if="property.hint">
        <b-icon-question-circle-fill class="question-hint" v-if="property.hint" :id="`popover-target-${property.id}`"></b-icon-question-circle-fill>
      </span>

      <b-popover v-if="property.hint" :target="`popover-target-${property.id}`" triggers="hover" placement="top">
        {{ property.hint}}
      </b-popover>
    </div>


    <div class="col-8">
      <component
        v-bind:is="answerType"
        :answer="property.answer"
        :questionId="property.id"
        :isUser="false"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Property } from "@/entities/questionaire/Property";
import AppBooleanAnswer from "@/components/expert/answer-types/AppBooleanAnswer.vue";
import AppSingleItemAnswer from "@/components/expert/answer-types/AppSingleItemAnswer.vue";
import AppMultipleItemsAnswer from "@/components/expert/answer-types/AppMultipleItemsAnswer.vue";

@Component({
  components: {
    AppBooleanAnswer,
    AppSingleItemAnswer,
    AppMultipleItemsAnswer
  }
})
export default class AppProperty extends Vue {
  answerType!: string;

  @Prop()
  property!: Property;

  created(): void {
    this.answerType = this.property.answer.getComponentName();
  }
}
</script>

<style scoped>
.failed {
  color: red;
}

.question-hint{
  position: absolute;
  top: -5px;
  cursor: pointer;
}

</style>
